import { useOktaAuth } from "@okta/okta-react";
import { UserClaims, CustomUserClaims } from "@okta/okta-auth-js";
import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import { useLDClient } from "launchdarkly-react-client-sdk";

export const UserContext = createContext<UserClaims<CustomUserClaims> | null>(
  null
);

export const UserContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const ldCient = useLDClient();
  const [userInfo, setUserInfo] = useState<UserClaims<CustomUserClaims> | null>(
    null
  );

  const oktaAuthState = useOktaAuth();

  useEffect(() => {
    if (oktaAuthState.authState?.isAuthenticated) {
      oktaAuthState.oktaAuth.getUser().then((user) => {
        setUserInfo(user);
      });
    }
    return () => {
      setUserInfo(null);
    };
  }, [oktaAuthState.authState?.isAuthenticated]);

  useEffect(() => {
    if (userInfo) {
      ldCient?.identify({
        kind: "user",
        key: userInfo.sub,
      });
    }
  }, [userInfo]);

  return (
    <UserContext.Provider value={userInfo}>{children}</UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
